import apiV2Service from 'common/src/modules/api/api-v2.service';
import {
  ProductStrategyMetadata_UI,
  RemoteProductStrategyMetadata,
  toClientProductStrategyMetadata,
} from './productSelectionStrategies.types';

async function getProductStrategies(campaignId?: number): Promise<ProductStrategyMetadata_UI[]> {
  const {data} = await apiV2Service.executeGetRequest<RemoteProductStrategyMetadata[]>(
    'ProductStrategies',
    campaignId ? {campaignId} : {},
  );

  return data.map(toClientProductStrategyMetadata);
}

const productSelectionStrategiesApi = {
  getProductStrategies,
};

export default productSelectionStrategiesApi;
